// extracted by mini-css-extract-plugin
export default {"button":"GenerateProposalButton_button__F+682","icon":"GenerateProposalButton_icon__b1Mde"};